import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import useViewPageObject from "../../../../../hooks/redux/useViewPageObject";
import { VIEW_TYPES } from "../../../../../config/registers/view/types";
import { getProfessionalQualification } from "../../../../../axios/api/services";
import useViewObjectControl from "../../../../../hooks/registers/view/useViewObjectControl";
import { BlockText, BoxSpg, CardSpg, Page404 } from "@duosoftbg/nacid-components";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { CardContent, CircularProgress, Grid } from "@mui/material";
import React, { useCallback } from "react";

const ProfessionalQualificationView = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const object = useViewPageObject();
  const data = object?.data;
  const viewType = VIEW_TYPES.PROFESSIONAL_QUALIFICATION;
  const qualifId = searchParams.get("id");
  const serviceFn = useCallback(getProfessionalQualification(qualifId), [qualifId]);
  const { isLoading, notFound } = useViewObjectControl({ viewType, serviceFn, viewId: qualifId });
  const title = `${t("t.detail.professional.qualification")} ${object ? object.data?.applicationNumber : ""}`;

  if (notFound) {
    return <Page404 />;
  }

  return (
    <PageWrapper title={title}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          {isLoading && (
            <BoxSpg my={2} sx={{ display: "flex", boxShadow: 3 }} style={{ justifyContent: "center" }}>
              <CircularProgress size={20} />
            </BoxSpg>
          )}
          {data && (
            <Grid container rowSpacing={3}>
              <BlockText withGrid label={"l.detail.applicationNumber"} text={data.applicationNumber} />
              <BlockText withGrid label={"l.detail.applicationDate"} text={data.applicationDate} />
              <BlockText withGrid label={"l.detail.applicationStatus"} text={data.applicationStatus?.name} />
              <BlockText withGrid label={"l.detail.applicantName"} text={data.applicantName} />
              <BlockText withGrid label={"l.detail.applicationCountryName"} text={data.applicationCountryName} />
              <BlockText withGrid label={"l.detail.decisionNumber"} text={data.decisionNumber} />
              <BlockText withGrid label={"l.detail.recognizedProfessionName"} text={data.recognizedProfessionName} />
            </Grid>
          )}
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default ProfessionalQualificationView;
